export default "__VITE_ASSET__DgKvrwCS__"